import { Grid } from '@mui/material';

import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SavePaymentMethodV2 } from '../../shared/components';

export type CreatePaymentMethodV2PageProps = {};

const CreatePaymentMethodV2Page: React.FC<CreatePaymentMethodV2PageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_formapago);

  return (
    <Grid container spacing={2} padding="24px">
      <SavePaymentMethodV2 titlePage="Crear Método de Pago V2" />
    </Grid>
  );
};

export default CreatePaymentMethodV2Page;
